import { Directive, Input, HostBinding } from '@angular/core';
import { BaseDirective } from '../base/_base.directive';

@Directive({
  selector: '[downArrowIcon]',
  exportAs: 'down-arrow-icon'
})
export class DownArrowIconDirective extends BaseDirective {
  visible: boolean = true;

  @HostBinding('class.direction-top') @Input() up: boolean = false;

  @HostBinding('class.icon') iconClass: boolean = true;

  @HostBinding('class.down-blue-arrow-icon') arrowIconClass: boolean = true;

  @HostBinding('class.hidden') get isHidden() {
    return !this.visible;
  }

  public toggle() {
    this.up = !this.up;
  }

  public setUp(up: boolean = false) {
    this.up = up;
  }

  public setVisible(visible: boolean = true) {
    this.visible = visible;
  }

}
